import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import SimpleTooltipText from '../SimpleTooltipText';
import s from './SimpleTooltipContent.scss';
const SimpleTooltipContent = /*#__PURE__*/ React.forwardRef((_param, ref)=>/*#__PURE__*/ {
    var { prefix, postfix, children, className } = _param, rest = _object_without_properties(_param, [
        "prefix",
        "postfix",
        "children",
        "className"
    ]);
    return React.createElement("div", _object_spread({
        className: c(s['root'], className),
        ref: ref
    }, rest), prefix && /*#__PURE__*/ React.createElement("div", {
        className: s['prefix']
    }, prefix), /*#__PURE__*/ React.createElement(SimpleTooltipText, {
        className: s['text']
    }, children), postfix && /*#__PURE__*/ React.createElement("div", {
        className: s['postfix']
    }, postfix));
});
SimpleTooltipContent.displayName = 'SimpleTooltipContent';
export default SimpleTooltipContent;
